import { render, staticRenderFns } from "./user-details-modal.vue?vue&type=template&id=6f072b37"
import script from "./user-details-modal.vue?vue&type=script&lang=js"
export * from "./user-details-modal.vue?vue&type=script&lang=js"
import style0 from "./user-details-modal.vue?vue&type=style&index=0&id=6f072b37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports